import { getStaticAssetUrl } from 'utils/url';

export const TIERS = {
  NO_TIER: 'NO_TIER',
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  DIAMOND: 'DIAMOND',
} as const;

export type TierId = keyof typeof TIERS;

export type Tier = {
  id: TierId;
  name: string;
  icon: string;
  srep: number;
};

export const tierList: Tier[] = [
  {
    id: TIERS.NO_TIER,
    icon: getStaticAssetUrl('/sfi/static/staking/tier_zero.png'),
    name: 'Zero',
    srep: 0,
  },
  {
    id: TIERS.BRONZE,
    icon: getStaticAssetUrl('/sfi/static/staking/tier_bronze.png'),
    name: 'Bronze',
    srep: 5000000,
  },
  {
    id: TIERS.SILVER,
    icon: getStaticAssetUrl('/sfi/static/staking/tier_silver.png'),
    name: 'Silver',
    srep: 20000000,
  },
  {
    id: TIERS.GOLD,
    icon: getStaticAssetUrl('/sfi/static/staking/tier_gold.png'),
    name: 'Gold',
    srep: 50000000,
  },
  {
    id: TIERS.DIAMOND,
    icon: getStaticAssetUrl('/sfi/static/staking/tier_diamond.png'),
    name: 'Diamond',
    srep: 100000000,
  },
];

export const tierMap: Record<TierId, Tier> = tierList.reduce(
  (acc, tier) => {
    return { ...acc, [tier.id]: tier };
  },
  {} as Record<TierId, Tier>
);
